"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var event_1 = require("./event");
var spmDataKey = 'data-spm';
var spmDPosMarkAttr = 'data-spm-click';
var spmDParamMarkAttr = 'data-spm-param';
var spmDPosTagPattern = /^a|area$/i;
function Spm(tracker) {
    var spmModel = {
        init: function () {
            var _this = this;
            tracker.spmClick = this.spmClick.bind(this);
            event_1.default.addEvent(document, 'click', function (el) {
                try {
                    var targetEl = el.target;
                    var isDPos = _this.getDPosDom(targetEl);
                    if (isDPos) {
                        var abObj = _this.getSpmAb(tracker.spm);
                        var spmA = abObj.spmA || _this.getMetaSpm().spmAPos;
                        var spmB = abObj.spmB || _this.getSpmBPos();
                        var cPosData = _this.getSpmCPos(targetEl);
                        var dPosData = _this.getSpmDPos(targetEl);
                        var dPosParam = _this.getDomParam(targetEl);
                        var spmStr = spmA + "." + spmB + "." + cPosData + "." + dPosData;
                        _this.spmClick(spmStr, dPosParam);
                    }
                }
                catch (e) {
                }
            });
        },
        spmClick: function (spm, param) {
            if (!spm)
                return;
            var spmArr = spm.split('.');
            if (spmArr.length === 4) {
                tracker.log('log', {
                    s1: spm,
                    s2: (param && Object.keys(param).length > 0) ? param : undefined,
                    s5: "" + spmArr[0],
                    s3: spmArr[0] + "." + spmArr[1],
                    s4: spmArr[0] + "." + spmArr[1] + "." + spmArr[2],
                });
            }
            else if (spmArr.length === 2) {
                var spmA = this.getMetaSpm().spmAPos;
                var spmB = this.getSpmBPos();
                var spmStr = spmA + "." + spmB + "." + spm;
                tracker.log('log', {
                    s1: spmStr,
                    s2: (param && Object.keys(param).length > 0) ? param : undefined,
                    s5: "" + spmA,
                    s3: spmA + "." + spmB,
                    s4: spmA + "." + spmB + "." + spmArr[2]
                });
            }
        },
        getSpmAb: function (spm) {
            if (!spm)
                return {};
            var spmArr = spm.split('.');
            if (spmArr.length != 2) {
                // console.log('传入参数不合法, 正确格式: a位.b位');
                return {
                    spmA: this.getMetaSpm().spmAPos || '',
                    spmB: spm,
                };
            }
            var spmA = spmArr[0];
            var spmB = spmArr[1];
            return {
                spmA: spmA,
                spmB: spmB,
            };
        },
        // 将dom转化为Array
        nodeListToArray: function (nodes) {
            var arr;
            var length;
            try {
                arr = [].slice.call(nodes);
                return arr;
            }
            catch (err) {
                arr = [];
                length = nodes.length;
                for (var i = 0; i < length; i++) {
                    arr.push(nodes[i]);
                }
                return arr;
            }
        },
        // 获取dom上面的属性
        getAttr: function (element, attrName) {
            return element && element.getAttribute ? (element.getAttribute(attrName) || '') : '';
        },
        // 判断是不是一个dom
        isDom: function (dom) {
            return dom !== null && typeof dom === 'object' && dom.nodeType === 1;
        },
        // 是否非body以及document的dom
        isViewDom: function (dom) {
            if (!dom || !this.isDom(dom) || dom === document.body || dom === document.documentElement) {
                return false;
            }
            return true;
        },
        /**
         * 获取页面spm元数据
         * 元数据包括：
         * 1. spm a位，在meta标签里 name 为 data-aspm 的 content 中
         * 2. 页面bizType，在meta标签里 name 为 data-bizType 的 content 中
         */
        getMetaSpm: function (metas) {
            var metaList = this.nodeListToArray(metas || document.getElementsByTagName('meta'));
            var len = metaList.length;
            var metaItem;
            var name;
            var content;
            var bizType;
            var spmAPos;
            for (var i = 0; i < len; i++) {
                metaItem = metaList[i];
                name = this.getAttr(metaItem, 'name');
                content = this.getAttr(metaItem, 'content');
                switch (name) {
                    case spmDataKey:
                        spmAPos = content;
                        break;
                    case 'data-bizType':
                        bizType = content;
                        break;
                    default:
                        break;
                }
                if (spmAPos && bizType) {
                    break;
                }
            }
            var ret = {
                spmAPos: '',
                bizType: '',
            };
            if (spmAPos) {
                ret.spmAPos = spmAPos;
            }
            if (bizType) {
                ret.bizType = bizType;
            }
            return ret;
        },
        /**
         * 获取spm b位数据
         * b位数据为 body 元素 data-aspm 的值
         */
        getSpmBPos: function () {
            var spmBPos = this.getAttr(document.body, spmDataKey);
            return spmBPos;
        },
        /**
         * 获取spm c位数据
         * c位数据挂载在dom上，属性 data-aspm 的值
         */
        getSpmCPos: function (el) {
            var dom = el;
            if (!this.isViewDom(dom)) {
                return '';
            }
            var spmCPos = '';
            while (dom && dom !== document.body) {
                spmCPos = this.getAttr(dom, spmDataKey);
                if (spmCPos) {
                    break;
                }
                dom = dom.parentNode;
            }
            return spmCPos;
        },
        /**
         * 判断是否为spmD的dom，如果是 返回这个 dom 对象，如果不是，返回null
         */
        getDPosDom: function (el) {
            var dom = el;
            if (!this.isViewDom(dom)) {
                return null;
            }
            do {
                if (spmDPosTagPattern.test(dom.tagName) && dom.hasAttribute(spmDPosMarkAttr)) {
                    return dom;
                }
            } while ((dom = dom.parentNode) && dom && dom.tagName && dom.tagName !== 'BODY' && dom !== document.body && !this.getAttr(dom, spmDataKey));
            return null;
        },
        /**
         * 获取spm d位数据
         * 1. 如果dom上有 data-spm-click 属性，则 d 位信息为其属性值
         * 2. 默认情况下会对 a, area 获取其在父元素中的索引作为其 d 位信息
         */
        getSpmDPos: function (el) {
            var dom = el;
            if (!this.isViewDom(dom)) {
                return '';
            }
            if (!(spmDPosTagPattern.test(dom.tagName) || dom.hasAttribute(spmDPosMarkAttr))) {
                dom = this.getDPosDom(dom);
            }
            if (!dom) {
                return '';
            }
            var spmDPos = this.getAttr(dom, spmDPosMarkAttr);
            var tagName = dom.tagName;
            if (typeof spmDPos === 'string' || spmDPosTagPattern.test(tagName)) {
                if (!spmDPos) {
                    var idx = 0;
                    var rollDom = dom;
                    do {
                        if (this.isDom(rollDom)) {
                            if (tagName === rollDom.tagName) {
                                idx++;
                            }
                        }
                        rollDom = rollDom.previousSibling;
                    } while (rollDom);
                    spmDPos = idx;
                }
            }
            return "" + spmDPos;
        },
        // 获取dom上面的 data-spm-param 的值并做解析
        getDomParam: function (dom) {
            var paramStr = dom && dom.getAttribute ? (dom.getAttribute(spmDParamMarkAttr) || '') : '';
            var result = {};
            if (paramStr) {
                var paramSplitList = paramStr.split('^');
                if (paramStr.indexOf('=') === -1) {
                    result = paramSplitList;
                }
                else {
                    var len = paramSplitList.length;
                    var paramItem = void 0;
                    var paramItemSplitList = void 0;
                    for (var i = 0; i < len; i++) {
                        paramItem = paramSplitList[i];
                        if (paramItem) {
                            paramItemSplitList = paramItem.split('=');
                            result[paramItemSplitList[0]] = paramItemSplitList[1] || '';
                        }
                    }
                }
            }
            return result;
        },
    };
    spmModel.init();
    return spmModel;
}
exports.default = Spm;
//# sourceMappingURL=spm.js.map